import { useAppSelector } from 'hooks/useAppSelector'
import { useProductsAndCategories } from 'hooks/useProductsAndCategories'
import React from 'react'
import { useAppDispatch } from 'reduxStore'
import { setDateAndTime, setTimeslotOrderlinesReturn } from 'reduxStore/ducks/returnFlow/reducers'

import type { DateAndTime } from '../../api-client'
import { SelectDateAndTimeBase } from '../Common/SelectDateAndTimeBase'

const SelectDateAndTime = ({ onNextStep }: { onNextStep: () => void }) => {
  const dispatch = useAppDispatch()
  const { timeslot, date } = useAppSelector((state) => state.returnFlow.dateAndTime)
  const coupon = useAppSelector((state) => state.returnFlow.coupon)
  const orderType = useAppSelector((state) => state.returnFlow.orderType)
  const items = useAppSelector((state) => state.returnFlow.items)
  const { timeslotsProducts, isLoading } = useProductsAndCategories({ couponCode: coupon })

  const handleClickOnNextStep = (dateAndTime: DateAndTime) => {
    const { date, timeslot } = dateAndTime

    if (!isLoading && timeslot?.productId && timeslotsProducts) {
      dispatch(
        setTimeslotOrderlinesReturn([
          { product: timeslotsProducts[timeslot.productId], quantity: 1 },
        ])
      )
    } else {
      dispatch(setTimeslotOrderlinesReturn([]))
    }

    if (date && timeslot) {
      dispatch(setDateAndTime({ timeslot, date }))
      onNextStep()
    }
  }

  return (
    <SelectDateAndTimeBase
      preSelectedDate={date}
      preSelectedTimeslot={timeslot}
      items={items}
      orderType={orderType}
      onNext={handleClickOnNextStep}
    />
  )
}

export { SelectDateAndTime }
